import { FC } from 'react';
import { ReactComponent as NotificationDoneFillIcon } from '@epam/assets/icons/notification-done-fill.svg';
import { ReactComponent as NavigationCloseFillIcon } from '@epam/assets/icons/navigation-close-fill.svg';
import { ReactComponent as ActionDeleteFillIcon } from '@epam/assets/icons/action-delete-fill.svg';
import { ReactComponent as ContentEditFillIcon } from '@epam/assets/icons/content-edit-fill.svg';
import { TComment } from './types';
import { FlexRow, IconButton } from '@epam/promo';

interface ICommentActionsProps {
  isEditable: boolean;
  onConfirmEdit: (commentId: string, newValue: string) => void;
  onRejectEdit: (commentId: string) => void;
  onStartEdit: (commentId: string) => void;
  onRemove: (commentId: string) => void;
  comment: TComment;
  editedValue: string;
}

export const CommentActions: FC<ICommentActionsProps> = ({
  isEditable,
  onStartEdit,
  onRemove,
  onConfirmEdit,
  onRejectEdit,
  comment,
  editedValue,
}) => (
  <>
    {isEditable && (
      <FlexRow columnGap="6">
        <IconButton
          icon={ContentEditFillIcon}
          size="24"
          onClick={() => onStartEdit(comment.id)}
        />
        <IconButton
          icon={ActionDeleteFillIcon}
          onClick={() => onRemove(comment.id)}
        />
      </FlexRow>
    )}
    {comment.editMode && (
      <FlexRow>
        <IconButton
          icon={NotificationDoneFillIcon}
          isDisabled={!editedValue.trim() || editedValue === comment.value}
          onClick={() => onConfirmEdit(comment.id, editedValue)}
        />
        <IconButton
          icon={NavigationCloseFillIcon}
          onClick={() => onRejectEdit(comment.id)}
        />
      </FlexRow>
    )}
  </>
);
